import {axios, HOST, config} from './settiing';

export default {
  getMapDrivingPath(data) {
    const param = encodeURI(data);
    return axios.get(`${HOST}/maps/driving/${param}`, config);
  },
  deliveryDrivingInfo(data) {
    return axios.post(`${HOST}/maps/delivery/driving`, data, config)
  }
}